export interface Chapter {
  id: string;
  mangaId: string;
  index: number;
  title: string;
  publishedAt: string;
  views: string;
  content: string[];
}

export const otherChapters: Record<string, Chapter[]> = {
  naruto: [
    {
      id: "chap-naruto-001",
      mangaId: "naruto",
      index: 1,
      title: "第1话 漩涡鸣人",
      publishedAt: "2026-08-02",
      views: "203.1万",
      content: [
        "木叶忍者村的村口,竖着刻有历代火影头像的火影岩。而在岩壁下方,一个满头金发的少年正被村民们躲着走——他叫漩涡鸣人,体内封印着九尾妖狐。",
        "鸣人拼命恶作剧,只为让大人们注意到自己。他把火影岩涂得乱七八糟,却在墙上歪歪扭扭地写下:「我要成为火影,让你们都认可我!」",
        "这一天,鸣人从忍者学校毕业考核中落榜了。但在水下,他却在老师伊鲁卡的眼泪中爆发出了惊人的查克拉。忍者之路,从这一刻正式开始。",
      ],
    },
    {
      id: "chap-naruto-100",
      mangaId: "naruto",
      index: 100,
      title: "第100话 佐助的抉择",
      publishedAt: "2026-08-06",
      views: "188.7万",
      content: [
        "大蛇丸的诱惑让佐助内心动摇。为了获得杀死宇智波鼬的力量,佐助决定叛离木叶,追随大蛇丸。",
        "深夜,佐助背起行囊走出村子。鸣人一路追赶,两人在终结谷对峙。螺旋丸与千鸟轰然对撞,终结谷的上空被查克拉照亮。",
        "「鸣人,你这吊车尾……为什么这么执着于我?」「因为我们是伙伴啊,佐助!」少年们的呐喊,化作木叶上空最刺眼的雷光。",
      ],
    },
    {
      id: "chap-naruto-700",
      mangaId: "naruto",
      index: 700,
      title: "第700话 漩涡鸣人!!",
      publishedAt: "2026-08-11",
      views: "265.4万",
      content: [
        "忍界大战落幕,木叶村恢复了和平。鸣人终于实现了儿时的梦想,成为了第七代火影,娶了雏田,还生下了儿女。",
        "火影岩上,新增了鸣人微笑的头像。村民们在广场上仰望着那张熟悉的脸,仿佛还能听见当年那个金发小鬼的呐喊。",
        "「说到做到,就是我的忍道!」——漩涡鸣人的故事结束了,但他的火之意志,将一代代传承下去。感谢这部陪伴无数人青春的《火影忍者》。",
      ],
    },
  ],
  "one-piece": [
    {
      id: "chap-onepiece-001",
      mangaId: "one-piece",
      index: 1,
      title: "第1话 我是路飞,要成为海贼王的男人",
      publishedAt: "2026-08-02",
      views: "312.5万",
      content: [
        "风车村的岸边,少年路飞吃过恶魔果实「橡胶果实」后,再也无法游泳,却依然梦想着出海成为海贼王。",
        "他认识了想要出海的海贼团船长的女儿,和立志成为世界第一大剑豪的剑士。路飞跳上小船,笑着大喊:「我要去找能够一起航海、能够互相托付性命的伙伴!」",
        "大海的浪花卷起,路飞的故事,从这个小村庄正式启航。",
      ],
    },
    {
      id: "chap-onepiece-500",
      mangaId: "one-piece",
      index: 500,
      title: "第500话 伙伴的印记",
      publishedAt: "2026-08-09",
      views: "240.8万",
      content: [
        "司法岛事件后,草帽一伙为了救回罗宾与世界政府正面开战。路飞命令伙伴们站在屋顶上,亲手烧掉了世界政府的旗帜。",
        "罗宾流着泪喊出:「我想活下去!」那一刻,「伙伴」这两个字的分量,比任何宝藏都要沉重。",
        "全员合力,敲响黄金钟的钟声回荡在大海之上。草帽一伙的悬赏金,从此开始一路飙升。",
      ],
    },
    {
      id: "chap-onepiece-1120",
      mangaId: "one-piece",
      index: 1120,
      title: "第1120话 传说中的战士",
      publishedAt: "2026-08-14",
      views: "198.2万",
      content: [
        "和之国篇落幕,草帽一伙向着最终之岛「拉夫德鲁」迈进。路飞距离海贼王的宝座,只剩最后一步。",
        "「我已经把‘那个秘密’告诉伙伴们了。」路飞望着海平线,笑容依旧像当年在风车村时一样灿烂。",
        "传说中乔伊波伊的钟声,似乎正在某处静静等待。ONE PIECE,就在那片传奇的大海尽头。",
      ],
    },
  ],
  bleach: [
    {
      id: "chap-bleach-001",
      mangaId: "bleach",
      index: 1,
      title: "第1话 死神与草莓",
      publishedAt: "2026-08-03",
      views: "145.9万",
      content: [
        "高中生黑崎一护能够看见幽灵,因此总能遇见各种麻烦。一天夜里,他遇到了死神朽木露琪亚,并卷入了「虚」的攻击。",
        "为了保护妹妹,一护挡在了虚的面前。露琪亚重伤之际,将死神之力灌注进一护的体内——巨大的斩魄刀在他手中显现。",
        "「从今天起,你就是代理死神了。」露琪亚的话音未落,一护已经挥刀斩向了眼前的虚。",
      ],
    },
    {
      id: "chap-bleach-686",
      mangaId: "bleach",
      index: 686,
      title: "第686话 死神与虚与灭却师",
      publishedAt: "2026-08-12",
      views: "167.3万",
      content: [
        "千年血战篇结束,尸魂界、现世与虚圈的秩序终于重归平衡。一护站在空座町的天台上,风吹过他的衣角。",
        "露琪亚继承了护廷十三队总队长之位,而一护则回归了普通的生活,却依然随时准备为重要的人挥刀。",
        "「谢谢你,露琪亚。」一护望着远方的天空,露出一个安心的笑容。BLEACH的故事在此落幕,但守护的意志永不熄灭。",
      ],
    },
  ],
  gintama: [
    {
      id: "chap-gintama-001",
      mangaId: "gintama",
      index: 1,
      title: "第1话 天然卷都是好人",
      publishedAt: "2026-08-04",
      views: "102.6万",
      content: [
        "江户时代末期,天人降临,武士时代宣告终结。银发武士坂田银时在歌舞伎町经营着一家万事屋,什么委托都接。",
        "今天他接到了寻找失踪宠物的委托,结果一路查下去,牵扯出了一桩惊天大案。银时挖着鼻孔,懒洋洋地吐槽着任务的无聊。",
        "可当刀真正出鞘的那一刻,没有人会怀疑这个废柴大叔的含金量。",
      ],
    },
    {
      id: "chap-gintama-704",
      mangaId: "gintama",
      index: 704,
      title: "第704话 银魂",
      publishedAt: "2026-08-10",
      views: "138.4万",
      content: [
        "大战结束,世界重归和平。万事屋的三个人,依然在歌舞伎町吵吵闹闹地过着每一天。",
        "「人生就是不断地在废柴和更废柴之间挣扎啊。」银时叼着棒棒糖,一脸无所谓地说着,却把手里的最后一块糖分给了伙伴。",
        "就这样,银魂的日常在欢声笑语中继续着。因为对于他们来说,这样的日子,就已经是最好的结局了。",
      ],
    },
  ],
  hunter: [
    {
      id: "chap-hunter-001",
      mangaId: "hunter",
      index: 1,
      title: "第1话 踏上旅途的男孩",
      publishedAt: "2026-08-05",
      views: "156.8万",
      content: [
        "鲸鱼岛的少年小杰,一直相信父亲金还活着。为了寻找那个抛弃自己的猎人父亲,他决定参加传说中的「猎人考试」。",
        "在考试会场,他结识了同样前来考试的酷拉皮卡、雷欧力和奇犽。四个少年各怀心事,却结下了不解之缘。",
        "「我要成为一个像父亲一样伟大的猎人!」小杰的眼里闪着光,考试的第一关,就此开始。",
      ],
    },
    {
      id: "chap-hunter-400",
      mangaId: "hunter",
      index: 400,
      title: "第400话 黑暗大陆",
      publishedAt: "2026-08-13",
      views: "121.5万",
      content: [
        "会长选举落幕,猎人世界的目光转向了传说中的「黑暗大陆」。那是人类从未踏足的禁忌之地,也是无数猎人的终极目标。",
        "奇犽与妹妹阿路加的故事告一段落,小杰则踏上了追寻父亲足迹的新旅程。",
        "黑暗大陆的巨浪之下,新的冒险正在酝酿。富坚义博的世界,永远比想象中更广阔。",
      ],
    },
  ],
  aot: [
    {
      id: "chap-aot-001",
      mangaId: "aot",
      index: 1,
      title: "第1话 两千年后的你",
      publishedAt: "2026-08-06",
      views: "189.3万",
      content: [
        "「那一天,人类终于回想起了被巨人支配的恐惧……」百年来,人类蜷缩在三重高墙之内苟延残喘。",
        "少年艾伦向往墙外的世界,却亲眼目睹了超大型巨人一脚踹破玛利亚之墙,母亲在眼前被巨人吞噬。",
        "「我要把所有巨人,一个不剩地驱逐出去!」艾伦的怒吼,点燃了整部作品的序章。",
      ],
    },
    {
      id: "chap-aot-139",
      mangaId: "aot",
      index: 139,
      title: "第139话 迈向山丘上的那棵树",
      publishedAt: "2026-08-12",
      views: "232.7万",
      content: [
        "地鸣被阻止,世界付出了惨烈的代价。艾伦选择让挚友们成为拯救世界的英雄,自己则背负起一切。",
        "多年后,三笠独自来到那棵树下,将代表自由的围巾轻轻系好。风吹过山丘,仿佛有人在她耳边低语:「谢谢你,为我围上围巾。」",
        "《进击的巨人》的故事在此完结。关于自由与仇恨的答卷,留给每一位读者去思考。",
      ],
    },
  ],
  opm: [
    {
      id: "chap-opm-001",
      mangaId: "opm",
      index: 1,
      title: "第1话 一拳超人",
      publishedAt: "2026-08-07",
      views: "167.9万",
      content: [
        "光头青年琦玉,在三年前拼尽全力锻炼后,变成了「一拳就能解决一切」的强者。然而,他却陷入了无敌的寂寞。",
        "「最强的代价,就是连热血的感觉都失去了。」琦玉一边感慨,一边一拳打飞了袭击城市的巨大怪人。",
        "直到他遇见了崇拜自己的改造人杰诺斯,平淡的日常,才开始有了新的色彩。",
      ],
    },
    {
      id: "chap-opm-230",
      mangaId: "opm",
      index: 230,
      title: "第230话 新英雄",
      publishedAt: "2026-08-13",
      views: "98.6万",
      content: [
        "怪人协会大战之后,英雄协会迎来了变革。琦玉依然是那个面无表情的S级英雄,却慢慢理解了「强大」之外的东西。",
        "「英雄不是为了排名而战的。」琦玉难得认真地说了一句话,让在场的英雄们哑口无言。",
        "新英雄的时代已经到来,而一拳超人琦玉,依然在寻找着能让心脏重新跳动起来的战斗。",
      ],
    },
  ],
  jujutsu: [
    {
      id: "chap-jujutsu-001",
      mangaId: "jujutsu",
      index: 1,
      title: "第1话 两面宿傩",
      publishedAt: "2026-08-08",
      views: "143.2万",
      content: [
        "高中生虎杖悠仁是个体能怪物,却只想平静地过校园生活。某天,他为了救下学长学姐,吞下了特级咒物「两面宿傩之指」。",
        "诅咒之王宿傩在虎杖体内苏醒,东京咒术高专的五条悟找上门来。",
        "「你有两条路:被立即处刑,或者成为咒术师,等找到宿傩的手指全部吞下后再被处刑。」五条悟笑眯眯地说。虎杖选择了后者。",
      ],
    },
    {
      id: "chap-jujutsu-271",
      mangaId: "jujutsu",
      index: 271,
      title: "第271话 死灭洄游,终局",
      publishedAt: "2026-08-14",
      views: "176.1万",
      content: [
        "涩谷事变、死灭洄游,一场场以命相搏的咒术大战落下帷幕。虎杖悠仁与伙伴们拼尽全力,终于将宿傩封印。",
        "「咒术师的战斗,从来不是为了自己。」虎杖站在废墟中,看着五条悟老师远去的背影,眼神坚定。",
        "东京咒术高专的旗帜在风中飘扬,新的诅咒、新的战斗,仍在等待着这群年轻的咒术师。",
      ],
    },
  ],
  kuroko: [
    {
      id: "chap-kuroko-001",
      mangaId: "kuroko",
      index: 1,
      title: "第1话 黑子哲也",
      publishedAt: "2026-08-09",
      views: "88.4万",
      content: [
        "诚凛高校篮球部来了一个存在感极低的新生——黑子哲也。他自称是「奇迹的世代」的幻之第六人,却没有人相信。",
        "直到训练赛上,黑子用一手神乎其神的传球,把球无声无息地送进队友手中,全场都惊呆了。",
        "「我的篮球,就是让队友变得更强。」黑子平静地说,身旁是从美国归来的天才火神大我。",
      ],
    },
    {
      id: "chap-kuroko-275",
      mangaId: "kuroko",
      index: 275,
      title: "第275话 光与影",
      publishedAt: "2026-08-11",
      views: "96.7万",
      content: [
        "冬季杯决赛,诚凛与奇迹的世代展开最后的对决。火神与黑子这对「光与影」的组合,爆发出最强的力量。",
        "「我永远相信我的影子。」火神跃起灌篮的瞬间,黑子的传球穿过所有防线。",
        "终场哨响,诚凛夺冠。黑子哲也的篮球,终于在这个冬天,绽放出了最耀眼的光芒。",
      ],
    },
  ],
  shokugeki: [
    {
      id: "chap-shokugeki-001",
      mangaId: "shokugeki",
      index: 1,
      title: "第1话 无尽的荒野",
      publishedAt: "2026-08-10",
      views: "79.5万",
      content: [
        "幸平创真从小就帮父亲经营大众食堂「幸平餐馆」,练就了一手好厨艺。他以为自己的料理已经天下无敌,直到他考进了料理界的顶点「远月学园」。",
        "入学测试上,创真被天才少女薙切绘里奈用一道精美的料理狠狠打击。他这才明白,世界比自己想象的广阔得多。",
        "「我要用我的料理,征服这个学园!」创真撸起袖子,一场又一场食戟对决即将开始。",
      ],
    },
    {
      id: "chap-shokugeki-325",
      mangaId: "shokugeki",
      index: 325,
      title: "第325话 料理人的世界",
      publishedAt: "2026-08-12",
      views: "85.9万",
      content: [
        "远月学园毕业后,创真开了一家属于自己的小餐馆。没有华丽的装潢,只有一颗认真对待每一道料理的心。",
        "「料理没有标准答案,只有想不想做给某个人吃。」创真把一盘热气腾腾的盖饭端上桌,顾客露出了幸福的笑容。",
        "从大众食堂到远月学园再到更大的世界,幸平创真的料理人生,依然在继续。",
      ],
    },
  ],
  "fairy-tail": [
    {
      id: "chap-fairytail-001",
      mangaId: "fairy-tail",
      index: 1,
      title: "第1话 妖精的尾巴",
      publishedAt: "2026-08-11",
      views: "92.3万",
      content: [
        "魔法大陆菲欧烈的魔导士公会「妖精的尾巴」,是出了名的「问题儿童聚集地」。公会门口挂着巨大的招牌,里面永远吵吵闹闹。",
        "纳兹带着他的猫伙伴快乐接下委托,却在任务途中遇见了迷路的少女露西。露西崇拜妖精的尾巴已久,两人一拍即合。",
        "「欢迎加入妖精的尾巴!」纳兹露出大大的笑容。公会的魔法火焰,又壮大了几分。",
      ],
    },
    {
      id: "chap-fairytail-545",
      mangaId: "fairy-tail",
      index: 545,
      title: "第545话 妖精的尾巴,永远",
      publishedAt: "2026-08-13",
      views: "118.5万",
      content: [
        "最终之战落幕,妖精的尾巴的魔法师们完成了各自的梦想。纳兹与露西,也终于走到了彼此心意的终点。",
        "「妖精的尾巴不是由建筑物决定的,而是由里面的每一个人决定的。」公会大门上的标志,依然在阳光下闪耀。",
        "故事的结尾,公会举行了盛大的宴会。火焰、魔法与友情,永远属于妖精的尾巴。",
      ],
    },
  ],
};